import * as types from "../constants/approvalConstant";

let initialState = {
  approvals: [],
  approval: null,
  isLoadingApproval: true,
};

const appReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.GET_APPROVALS:
      return { ...state, approvals: action.approvals };
    case types.GET_APPROVAL:
      return { ...state, approval: action.approval };
    case types.UPDATE_APPROVALS:
      return { ...state, approval: action.approval };
    case types.GET_ALL_APPROVALS:
      return {
        ...state,
        approvals: action.approvals,
        isLoadingApproval: action.isLoadingApproval,
        approvalDropdown: action.approvalDropdown,
        glDropdown: action.glDropdown
      };
    default:
      return state;
  }
};

export default appReducer;
